import React, { Component } from 'react';
import { css } from 'aphrodite';

import { Font, Layout, Flexbox } from './Styles';

class PrimaryButton extends Component {
  render() {
    return(
      <div className={css(Font.button, Layout.button, Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter)}>
        {this.props.children}
      </div>
    );
  }
}

export default PrimaryButton;



// WEBPACK FOOTER //
// ./src/PrimaryButton.js